<template>
    <div>
        <div class="headerBanner" v-if="!isMobile">
            <div class="headerBannerBg" :style="`background-image: url(${bannerBg});`">
                <img class="title" :src="title" alt="">
                <img class="desc" :src="desc" alt="">
            </div>
        </div>
        <div class="bannerShow" v-if="isMobile">
            <img class="bannerImg" :src="bannerBg" alt="">
            <img class="titleShow" :src="title" alt="">
            <img class="descShow" :src="desc" alt="">
        </div>
    </div>
</template>

<script>
import banner from '@/assets/cooperate/banner.png'
import title from '@/assets/cooperate/title.png'
import desc from '@/assets/cooperate/desc.png'
export default {
    name: 'cooperate',
    data() {
        return {
            bannerBg:banner,
            title:title,
            desc:desc,
        };
    },
    watch: {
        },
    mounted(){
        
    },
    methods: {
        //二级导航跳转
        turnClick(url){
            this.$router.push({
                path:url
            })
        }
    }
}
</script>
<style scoped>
     .headerBannerBg {
        height: 260px;
        background-size: cover;
        background-position: center;
    }
    .title{
        display: block;
        width:439px;
        margin: 0 auto;
        padding-top: 76px;
    }
    .desc{
        display: block;
        width: 631px;
        margin: 0 auto;
        margin-top: 35px;
    }
     /* 手机端banner图 */
     .bannerShow{
        position: relative;
        height: 150px;
    }
    .bannerImg{
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        width: 100%;
        height: 150px;
    }
    .titleShow{
        display: block;
        width: calc(100% - 60px);
        margin: 0 auto;
        padding-top: 40px;
    }
    .descShow{
        display: block;
        width: 95%;
        margin: 0 auto;
        margin-top: 20px;
    }
</style>